// Who sent an entry, for the table, the CSV and the entry drawer
// (public-form plan §4, T25). A web entry from someone who isn't logged in
// has no user and no snapshot name, so it reads "Guest (web)". A snapshot
// name always wins: an app user who later deleted their account keeps the
// name they submitted with.

export const GUEST_LABEL = 'Guest (web)';

export const isGuestEntry = (row) =>
  !!row && row.user_id == null && row.source === 'web';

export const submitterLabel = (row) =>
  (row && row.submitter_name) || (isGuestEntry(row) ? GUEST_LABEL : '');

export const submitterEmail = (row) => (row && row.submitter_email) || '';
